import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { SmsService } from 'src/app/services/sms-service/smsservice';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { ConfirmationDialogComponent } from 'src/app/components/shared-components/confirmation-dialog/confirmation-dialog.component';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-sms-sms-resume-card',
  templateUrl: './sms-sms-resume-card.component.html',
  styleUrls: ['./sms-sms-resume-card.component.scss']
})
export class SmsSmsResumeCardComponent implements OnInit, OnDestroy {

  @Input() sms;
  @Input() viewDisposition;
  updateSmsStatusSubscription: Subscription;
  deleteSmsSubscription: Subscription;

  constructor(private smsService: SmsService,
              private snackbarService: SnackBarService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              public dialog: MatDialog) { }

  ngOnInit() { }

  public toggleStatus() {
    this.updateSmsStatusSubscription = this.smsService.updateSmsStatus(this.sms.InternalId, !this.sms.Active).subscribe(
      (res) => {
        this.sms.Active = !this.sms.Active;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public gotoDetails(e) {
    if ((e.target.className !== 'mat-icon notranslate material-icons mat-icon-no-color') && (e.target.className !== 'mat-icon-button') && (e.target.tagName !== 'SPAN')) {
      this.router.navigate(['/account/sms', this.sms.InternalId], { relativeTo: this.activatedRoute });
    }
  }

  public deleteSms() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'important',
        messages: ['sms-page.delete sms', 'delete anyway']
      }
    });

    dialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.deleteSmsSubscription = this.smsService.deleteSms(this.sms.InternalId).subscribe(
          (res) => {
            this.smsService.refreshSmsList();
          },
          (error) => {
            this.snackbarService.open(error['error']['message'], 'error');
          }
        );
      }
    });
  }

  public getSmsCentersString() {
    if (this.sms && this.sms.Centers && (this.sms.Centers.length > 0)) {
      return this.sms.Centers.map(c => c.CenterName).join(', ');
    }
    return '';
  }

  ngOnDestroy() {
    if (this.updateSmsStatusSubscription) { this.updateSmsStatusSubscription.unsubscribe(); }
    if (this.deleteSmsSubscription) { this.deleteSmsSubscription.unsubscribe(); }
  }
}
